
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/enjoy-hq",
      function () {
        return require("private-next-pages/destinations/enjoy-hq.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/enjoy-hq"])
      });
    }
  